
const Storage = require('utils/localStorage/Storage');
const uiUtils = require('utils/UI');

function userXTimestampHeader(isCategoryPage = false) {
    const timestamp = Date.now();
    if (!isCategoryPage) {
        digitalData.page.attributes.date.timestamp = timestamp;
    }
    return {
        'x-timestamp': timestamp
    };
}

function setEventTimestampFBCapi(){
    let cookieUUId = Storage.local.getItem('uuid');       
    if (!cookieUUId) {
        let uuid = uiUtils.uuid();
        Storage.local.setItem('uuid', uuid);
        return uuid;
    }
    return cookieUUId;
}


module.exports = {
    userXTimestampHeader,
    setEventTimestampFBCapi
};
